module.exports = __webpack_public_path__ + "img/perfect.4e84b14c.jpg";